/* eslint-disable no-constant-binary-expression */
/* eslint-disable react/react-in-jsx-scope */
import React, { Fragment } from "react";
import { LuLogOut, LuUser } from "react-icons/lu";
import { cn } from "@/utils";
import { useDispatch, useSelector } from "react-redux";
import CustomSpinner from "../../../CustomSpinner";
import { logout } from "../../../../redux/authSlice";
import { t } from "i18next";
const avatarUrl = `${import.meta.env.VITE_AVATAR_URL}`;
const avatarType = "shapes";

const ProfileDropdown = () => {
  const { user, loading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(logout())
      .unwrap()
      .then(() => {
        // reload the page using navigate
        window.location.reload();
      });
  };
  const profileDropdownItems = [
    /* {
      icon: LuUser,
      name: "My Profile",
      link: "/admin/profile",
      style: "text-default-500 hover:bg-default-100",
    }, */

    {
      icon: LuLogOut,
      name: "Log Out",
      link: "/auth/login",
      onclick: handleLogout,
      style: "text-red-500 hover:bg-red-400/10",
    },
  ];

  return (
    <CustomSpinner
      text={t("categoryForm.loading") || "Loading..."}
      color="text-primary"
      isLoading={loading}
    >
      <div className="hs-dropdown relative inline-flex ">
        <button
          id="hs-dropdown-with-header"
          type="button"
          className="hs-dropdown-toggle inline-flex flex-shrink-0 items-center justify-center gap-2 rounded-full align-middle text-xs font-medium text-default-700 transition-all"
        >
          <img
            className="inline-block h-10 w-10 rounded-full"
            alt="avatar"
            src={`${avatarUrl}/${avatarType}/svg?seed=${user?.name} ${user?.surname}`}
          />
          <div className="hidden text-start lg:block">
            <p className="text-sm font-medium text-default-700">
              {` ${user?.name} ${user?.surname}` || "Kaiya Botosh"}
            </p>
            <p className="mt-1 text-xs text-default-500">{user?.role}</p>
          </div>
        </button>
        <div className="hs-dropdown-menu duration mt-2 hidden min-w-[12rem] rounded-lg border border-default-200 bg-white p-2 opacity-0 shadow-md transition-[opacity,margin] hs-dropdown-open:opacity-100 dark:bg-default-50">
          {profileDropdownItems.map((item, idx) => {
            const Icon = item.icon;
            const lastItem = profileDropdownItems.length - 1 == idx;
            return (
              <Fragment key={item.link + item.name}>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={item.onclick || null}
                  className={cn(
                    "flex items-center gap-x-3.5 rounded-md px-3 py-2 text-sm text-default-800 hover:bg-default-100",
                    lastItem && "text-red-500 hover:bg-red-400/10"
                  )}
                >
                  <Icon size={16} />
                  {item.name}
                </div>
              </Fragment>
            );
          })}
        </div>
      </div>
    </CustomSpinner>
  );
};

export default ProfileDropdown;
